import { logTime } from '@/core/utils'
import { useMagicKeys, whenever } from '@vueuse/core'
import { getCurrentInstance } from 'vue'

export function useDebugKeyCheckVideos() {
  const keys = useMagicKeys()

  function showPreviewVideoStatus() {
    console.debug(logTime(), 'showPreviewVideoStatus')
    document.querySelectorAll<HTMLVideoElement>('video.preview').forEach((el) => {
      const locationId = el.parentElement?.parentElement?.getAttribute('id')
      console.log({ locationId, played: !el.paused }, el.paused ? null : '<-- played')
    })
  }

  whenever(keys.v, () => {
    showPreviewVideoStatus()
  })
}
